export default __webpack_public_path__ + "static/media/ies_MasInfo_ENG.09834f90.png";